import React, { useState, useContext } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
// import * as AiIcons from "react-icons/ai";
import { SidebarData } from "./SidebarData";
import SubMenu from "./SubMenu";
import { IconContext } from "react-icons/lib";
import { UserContext } from "../pages/userContext";

const Nav = styled.div`
  background: #f8f8f8;
  height: 80px;
  top: 0;
  display: flex;
  
  align-items: center;
  position: fixed;
  width: 330px;
`;

const NavIcon = styled(Link)`
  margin-left: 2rem;
  font-size: 2rem;
  height: 80px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const SidebarNav = styled.nav`
  background: #f8f8f8;
  width: 330px;
  height: 100vh;
  display: flex;
  justify-content: center;
  position: fixed;
  top: 80px;
  left: ${({ $sidebar }) => ($sidebar ? "0" : "-100%")};
  transition: 350ms;
  z-index: 10;
`;

const SidebarWrap = styled.div`
  width: 100%;
`;

const Sidebar = () => {
  const [sidebar, setSidebar] = useState("true"); // Visible by default
  const { userDetails } = useContext(UserContext);

  const showSidebar = () => setSidebar(!sidebar);

  return (
    <IconContext.Provider value={{ color: "#FF4500" }}>
      <Nav>
        <img
          src={`${process.env.PUBLIC_URL}/images/cv_ifir_logo.png`}
          alt="Logo"
          style={{ height: "57px", width: "224px" }}
        />
        {/* <NavIcon to="#">
          <FaIcons.FaBars onClick={showSidebar} />
        </NavIcon> */}
      </Nav>
      <SidebarNav $sidebar={sidebar}>
        <SidebarWrap>
          {/* <NavIcon to="#">
            <AiIcons.AiOutlineClose onClick={showSidebar} />
          </NavIcon> */}
          {SidebarData.map((item, index) => (
            <SubMenu item={item} key={index} />
          ))}
          <div style={{background: "#f8f8f8", bottom:0, position:"fixed", width:"330px", height:"60px", padding:"5px 20px"}}>
            Logged in as: 
            <p>{userDetails.dsm_name}</p>
          </div>
        </SidebarWrap>
      </SidebarNav>
    </IconContext.Provider>
  );
};

export default Sidebar;
